// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1Bayg","author":"Table_author__2wvzC","authorImage":"Table_authorImage__2ZwM7","unreadRow":"Table_unreadRow__2O-xW"};